<template>
    <b-taginput v-model="selection" :data="filteredCategories" autocomplete field="name" placeholder="Categories" @typing="getFilteredCategories">
    </b-taginput>
</template>

<script>
import BTaginput from 'buefy/src/components/taginput/Taginput';

export default {
  components: { BTaginput },
  name: 'category-select-dropdown',

  props: ['selection'],

  data() {
    return {
      filteredCategories: [],
    };
  },

  created() {
    this.$store.dispatch('adminCategories/load');
  },

  methods: {
    getFilteredCategories(text) {
      if (this.categories !== null) {
        this.filteredCategories = this.categories.filter(
          (c) =>
            c.name
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0,
        );
      } else this.filteredCategories = [];
    },
  },

  computed: {
    categories() {
      return this.$store.state.adminCategories.categories;
    },

    loading() {
      return this.$store.state.adminCategories.loading;
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/CategorySelectDropdown.vue